import {http} from './../helpers/http-helper';
import {MemberReceiptsStatistics} from './../classes/member-receipts-statistics';

function createMemberReceiptsStatisticsFromResponse(response) {
    return new MemberReceiptsStatistics(
        response.uuid,
        response.fullName,
        response.code,
        (!!response.createdAt ? new Date(response.createdAt) : null),
        response.paymentMethod,
        response.periodicity,
        response.feeAmount,
        response.numReceipts,
        response.numReceiptsTreated,
        response.numReceiptsCharged,
        response.numReceiptsCanceled,
        (!!response.lastReceiptChargedDate ? new Date(response.lastReceiptChargedDate) : null)
    );
}

export const getMemberReceiptsStatistics = (memberId) => {
    return new Promise((resolve, reject) => {
        const url = 'statistics/members/' + memberId + '/receipts';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(createMemberReceiptsStatisticsFromResponse(response.data));
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getAccountingTable = (start, numberOfRanges, monthsPerRange, paymentMethods) => {
    return new Promise((resolve, reject) => {
        const url = 'statistics/receipts/accounting-table';
        http.get(url, {start, numberOfRanges, monthsPerRange, paymentMethods})
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getMemberSubscriptionEvolution = () => {
    return new Promise((resolve, reject) => {
        const url = 'statistics/members/subscription-evolution';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const getMemberStatisticsResume = (memberId) => {
    return new Promise((resolve, reject) => {
        const url = 'statistics/members/' + memberId + '/resume';
        http.get(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};
